import { useEffect, useState } from 'react'
import {useMediaQuery, Divider, Grid2, Typography, Box, Avatar, Button, Modal, TextField,Radio, RadioGroup, FormControl, FormControlLabel, IconButton, Autocomplete, Snackbar, Slide, Alert} from '@mui/material'
import ApiClient from '../utilities/apiClient'
import AppConfig from '../utilities/appConfig'
import moment from 'moment'
import styles from "./Accounts.module.css"
import AccountImage from "../assets/svg/account.png"
import CloseIcon from "@mui/icons-material/Close";
// import Verified from "../assets/svg/Greenverified.svg"
import Verified from "../assets/svg/verified.svg"
import Untick from "../assets/svg/untick.svg"
import { useNavigate } from "react-router-dom"
import { ThreeDots } from "react-loader-spinner";
import errorIcon from "../assets/svg/error.svg"
import logo from "../assets/svg/onlyLogo.svg"
import CryptoJS from "crypto-js"

function TransitionRight(props) {
    return <Slide {...props} direction="left" />;
  }

export default function Account ({
    accounts, 
    amount, 
    handlePayment,
    setUserBanks,
    setPaymentMode,
    paymentOrderId,
    paymentErrorMessage,
    paymentMode,
    paymentFailure,
    setPaymentFailure,
    userBanks, 
    selectedBank,
    setSelectedBank,
    setUser,
    setAmount,
}){

    const navigate = useNavigate()
//     const [account, setTest] = useState([
//         {
//         "name": "Tripti D Rao",
//         "client_id": "AAA206",
//         "subscription": "true",
//         "subscription_end_date": "2024-09-30T11:19:12.307Z"
//     },
//     {
//         "name": "Ayush Arjun Virnodkar",
//         "client_id": "AA1049",
//         "subscription": "true",
//         "subscription_end_date":  "2024-09-25T11:19:12.307Z"
//     },
//     {
//         "name": "Srinivasulu Kondal",
//         "client_id": "AA1048",
//         "subscription": "false",
//         "subscription_end_date": ""
//     },
//     {
//         "name": "Ramya Kodige",
//         "client_id": "AA1042",
//         "subscription": "true",
//         "subscription_end_date": "2025-09-21T11:19:12.307Z"
//     },
//     {
//         "name": "Srinivasullu kondal",
//         "client_id": "AA1045",
//         "subscription": "true",
//         "subscription_end_date": "2025-09-30T11:19:12.307Z"
//     },
// ])
    const storedAccounts = JSON.parse(localStorage.getItem('accounts') || '[]');
    const account = accounts.length !== 0 ? accounts : storedAccounts
    const amt = amount!=0? amount: JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('data'), process.env.REACT_APP_SECRET_KEY).toString(CryptoJS.enc.Utf8))?.subscription_fee
    const [selected, setSelected] = useState(account?.length !== 0 ? {client_id:account[0]?.client_id, name:account[0]?.name, subscription:account[0]?.subscription, sub_end_date:account[0]?.subscription_end_date}:{})
    const [selectPlan, setSelectPlan] = useState(true)
    const [modal , setModal] = useState(false)
    const [load, setLoad] = useState(false)
    const [snack, setSnack] = useState(false)
    const [snackmsg, setSnackmsg] = useState("")

    const isSmallScreen = useMediaQuery("(max-width : 700px)")
    const handleSnackClose = () => {
        setSnack(false)
    }
    // useEffect(()=>{
    //     localStorage.removeItem("transactionType")
    //     setAmount(amt)
    // },[])

    const handleBank = () => {
        setUser(selected)
        localStorage.setItem("account", JSON.stringify(selected))
            setLoad(true)
            const mobileno = localStorage.getItem("mobile")
            const apiClient = new ApiClient(localStorage.getItem('token'))
            
            apiClient.fetchData(AppConfig.api.Subscription.bankList, "POST", {
                mobileno:mobileno,
                client_id:selected?.client_id
            }).then((response)=>{
                console.log(response, "msg")
                if(response.Success == "False"){
                    setSnackmsg(response["Error Description"])
                    setSnack(true)
                    setLoad(false)
                }else{
                setUserBanks(response)
                if (response.length == 1) {
                    setSelectedBank(response[0])
                }
                else if (response.find(ele => ele.Default_Ac == "Yes")) {
                    const defaultBank = response?.length > 0 && response.find(ele => ele.Default_Ac == "Yes")
                    setSelectedBank(defaultBank)
                } else {
                    setSelectedBank(response[0])
                }
                setLoad(false)
                setModal(true)
            }
            }).catch((err)=>{
                setLoad(false)
                console.log(err,'error')
            })
        
    }

    const handleNavigate = () => {
        setUser(selected)
        localStorage.setItem("account", JSON.stringify(selected))
        navigate('/dashboard')
    }

    const handleBankChange = (e, newvalue) => {
        setSelectedBank(newvalue)
    }

    const handlePaymentModeChange = (e) => {
        setPaymentMode(e.target.value)
    }
  
    const handleClose = () => {
        setPaymentFailure(false)
    }


    const buttonStyle = {
        background: '#F3D45E !important',
        color: "#000000",
        fontSize: "18px",
        fontFamily: "Inter900",
        textTransform: "capitalize",
        width: "366px",
        height:"56px",
        borderRadius:'28px',
        mt: "20px",
        padding: "15px 37px 15px 37px",
        "@media only screen and (max-width: 500px)" : {
            width: "250px",
            fontSize: "15px",
        },
        "@media only screen and (max-width: 600px)" : {
            width: "250px",
            fontSize: "15px",
        },
        "@media only screen and (max-width: 750px)" : {
            width:"310px",
            marginTop:'10px',
           
        },
        "@media only screen and (max-height: 700px)": {
            marginTop: '5px !important'
        },
       

    }
    const buttonexp = {
        background: 'rgba(244, 188, 46, 1) !important',
        color: "#000000",
        fontSize: "18px",
        fontFamily: "Inter900",
        textTransform: "capitalize",
        width: "235px",
        borderRadius:'8px',
        mt: "20px",
        margin:'20px 15px 20px 15px',

        padding: "15px 37px 15px 37px",
        "@media only screen and (max-width: 500px)" : {
            width: "250px",
            fontSize: "15px",
        },
        "@media only screen and (max-height: 700px)" : {
            width: "180px",
            fontSize: '15px !important',
           
        },
        "@media only screen and (max-width: 560px)" : {
            width:"135px",
        },
        "@media only screen and (max-width: 332px)" : {
            margin:'20px 10px 20px 10px',
        }
    }


    // const buttonexp = {
    //     background: 'rgba(244, 188, 46, 1) !important',
    //     color: "#000000",
    //     fontSize: "18px",
    //     fontFamily: "Inter900",
    //     textTransform: "capitalize",
    //     width: "235px",
    //     borderRadius:'8px',
    //     mt: "20px",
    //     margin:"20px",
    //     margin:'15px 20px 20px 20px', 
    //     padding: "15px 37px 15px 37px",
    //     "@media only screen and (max-width: 500px)" : {
    //         width: "250px",
    //         fontSize: "25px",
    //     },
    //     "@media only screen and (max-height: 700px)" : {
    //         width: "180px",
    //         padding:"10px 15px 10px 15px !important",
    //         fontSize: '2.5vh !important'
    //     },
    //     "@media only screen and (max-width: 750px)" : {
    //         width:"135px",
    //         fontSize: "18px",
    //     }
    // }

return(
    <>
    <Snackbar
        anchorOrigin={{ vertical:'bottom', horizontal:'right' }}
        open={snack}
        onClose={handleSnackClose}
        autoHideDuration={5000}
        ContentProps={{
            sx: {
                width:'200px !important',
                backgroundColor: '#F5F5F5 !important', 
                color: '#000000 !important',
            },
          }}
        TransitionComponent={TransitionRight}
    >
            <Alert sx={{width:'250px'}} severity="error">{snackmsg}</Alert>
    </Snackbar>
    <div className={styles.main}>
        <Typography className={styles.userName}>Welcome {selected?.name}</Typography>
            <Typography className={styles.subtxt}>Congratulations for your wealth building journey with Bullforce</Typography>
        <Grid2 className={styles.accountGrid}>
            <Grid2>
                    <Typography className={styles.selectText}>Please select your account</Typography>
                    {
                        isSmallScreen &&
                        <Box className={styles.dividerBox}>
                            <Divider className={styles.divider} />
                        </Box> 
                    }
                   
            </Grid2>
            <Grid2 className={styles.accountboxGrid}>
                {
                    account?.map((ele)=>{
                        return <Box key={ele.client_id}
                        onClick={()=>{
                            setSelectPlan(true)
                            setSelected({client_id:ele.client_id, name:ele.name,subscription:ele.subscription, sub_end_date:ele.subscription_end_date})
                        }} 
                        sx={{border: selected?.client_id===ele.client_id? "1px solid #F3D45E" : null,}}
                            className={styles.accountBox}
                             >
                            <img src={AccountImage} alt="Account" className={styles.accountImage} />
                            <Typography className={styles.clientName} 
                            sx={{
                                whiteSpace: ele.name.length > 20 ? 'nowrap' : 'normal',
                                overflow: ele.name.length > 20 ? 'hidden' : 'visible',
                                textOverflow: ele.name.length > 20 ? 'ellipsis' : 'clip'
                              }}
                            >
                            {ele.client_id} - {ele.name}
                            </Typography>
                            {selected?.client_id ===ele.client_id && <Box sx={{ marginLeft: 'auto'}}>
                            <Avatar
                                alt="Verified"
                                src={Verified}
                                className={styles.avatar}
                            />
                            </Box>}
                        </Box>
                    })
                }
            </Grid2>    
        </Grid2>
        {selected?.subscription == 'false' || moment(selected.sub_end_date).diff(moment(), 'days') <=10?  <Grid2 className={styles.subGrid}>
            <Typography className={styles.userNameselect}>Select Plan</Typography>
            <Box onClick={()=>{setSelectPlan(true)}}className={styles.planBackground} sx={{border:selectPlan? '1px solid #F3D45E !important': null}} >
                <Box className={styles.logobox}>
                    <img src={logo} alt="Logo"  className={styles.bulllogo}/>
                </Box>
                <Grid2 className={styles.planGrid}>
                    <Typography className={styles.selectPlan}>Platinum plan</Typography>
                    <Grid2 className={styles.planSubGrid}>
                        <Typography className={styles.money}>₹{amt}</Typography>
                        <Typography className={styles.year}>Per/year + GST</Typography>
                    </Grid2>
                </Grid2>
                <Box className={styles.verifiedBox}>
                    <Avatar
                        alt="Verified"
                        src={selectPlan? Verified : Untick}
                        className={styles.verifiedAvatar}
                    />
                    </Box>
            </Box>
        </Grid2>: null}
        {
            moment(selected.sub_end_date).diff(moment(), 'days') <=10? <Grid2 >
                <Typography className={styles.planexp}>{`Your Subscription will end in ${moment(selected?.sub_end_date).diff(moment(), 'days')} ${moment(selected?.sub_end_date).diff(moment(), 'days') !=1 ? "days":'day'}!`}</Typography> 
                <Button  sx={buttonexp} onClick={handleBank} disabled={!selectPlan}>
            {!load ? "Subscribe" : <ThreeDots
                                    visible={true}
                                    height="31.5"
                                    width="40"
                                    color="#000000"
                                    radius="9"
                                    ariaLabel="three-dots-loading"
                                    wrapperStyle={{}}
                                    wrapperClass=""
                                />
            }
            </Button>
            <Button sx={buttonexp} onClick={()=>{
                setUser(selected)
                localStorage.setItem("account", JSON.stringify(selected))
                navigate('/dashboard')}} disabled={!selectPlan}>Proceed</Button>
            </Grid2>
             : 
             <Grid2 className={styles.saveButtonGrid}>
            <Button  sx={buttonStyle} onClick={handlePayment} disabled={!selectPlan}  >
            {!load ? "Proceed" : <ThreeDots
                                    visible={true}
                                    height="31.5"
                                    width="40"
                                    color="#000000"
                                    radius="9"
                                    ariaLabel="three-dots-loading"
                                    wrapperStyle={{}}
                                    wrapperClass=""
                                />
            }
            </Button>
    </Grid2>
        }
    </div>
    <Modal open={modal} onClose={() => {
                setModal(false)}} sx={{ border: "none" }}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "555px",
                        maxHeight: "435px",
                        overflowY: "auto",
                        outline: "none",
                        background: "#FFFFFF",
                        p: 4,
                        borderRadius: "16px",
                        padding: "31px 25px 75px 25px",
                        justifyContent: "center",
                        alignItems: "center",
                        display : "flex",
                        flexDirection : "column",
                        "@media only screen and (max-device-width: 650px)": {
                            width: "80%"
                        },
                        "@media only screen and (max-device-width: 375px)": {
                            width: "90%",
                            padding: "31px 5px 55px 5px",
                        },
                    }}
                >

                    <>
                    {/* added dev-Ayush 04-02-2025 start */}
                    <Grid2 sx={{ width: "100% !important",display : "flex", justifyContent : "end" , marginTop : "-15px" }}>
                            <IconButton onClick={() => {
                                setModal(false)
                            }}>
                                <CloseIcon sx={{ color: "black" }} />
                            </IconButton>
                        </Grid2>
                    <Grid2 >
                    {/*end*/}
                        <Typography className={styles.paymentText2}>Payment method</Typography>
                        <FormControl>
                            <RadioGroup
                                sx={{marginTop :"10px"}}
                                aria-labelledby="demo-radio-buttons-group-label"
                                value={paymentMode}
                                name="radio-buttons-group"
                                onChange={handlePaymentModeChange}
                                row
                            >
                                <FormControlLabel value="upi" control={<Radio sx={{
                                    color: "#000000",
                                    '&.Mui-checked': {
                                        color: "#000000",
                                    },
                                }} />} label={<Typography className={styles.paymentText} sx={{fontSize : "16px !important"}}>UPI</Typography>} />
                                <FormControlLabel value="netbanking" control={<Radio sx={{
                                    color: "#000000",
                                    '&.Mui-checked': {
                                        color: "#000000",
                                    },
                                }} />} label={<Typography className={styles.paymentText} sx={{fontSize : "16px !important"}}>Net Banking</Typography>} />

                            </RadioGroup>
                        </FormControl>
                        <Typography className={styles.paymentText3}>Select Bank Account</Typography>
                        <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={userBanks || []}
                        value={selectedBank}
                        onChange={handleBankChange}
                        getOptionLabel={(option) => paymentMode === "upi" ? (`${option.Bank_Name} - ${option.UPIBANKID || 'No Upi Id'}`) : (`${option.Bank_Name} - ${option.Bank_AcNo}`)}
                        size='small'
                        sx={{
                            marginTop: "10px",
                            width: "335px !important",
                            height: "40px",
                            borderRadius: "5px",
                            backgroundColor: "#FFFFFF",
                            '.MuiInputBase-input': {
                                color: 'black !important',
                            },
                            "@media only screen and (max-device-width: 460px)": {
                                width: "280px !important"
                            },
                            "@media only screen and (max-device-width: 375px)": {
                                width: "260px !important",
                            },
                    }}
                        renderInput={(params) => <TextField {...params} />}
                    />
                        <Typography className={styles.paymentText3}>Subscription amount</Typography>
                        <Typography sx={{fontSize:'24px',fontFamily:'Inter900', }}>₹{amount} <span style={{fontSize:'16px',fontFamily:'Inter600', }}>+ 18% GST</span></Typography>
                             <Button className={styles.loginbutton} 
                             onClick={()=>{
                                localStorage.setItem("paymentType","subscription")
                                handlePayment()
                             }}
                             >{!load ? "Proceed to Pay" : <ThreeDots
                                visible={true}
                                height="50"
                                width="50"
                                color="#000000"
                                radius="9"
                                ariaLabel="three-dots-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                            />}</Button>
                    </Grid2>
                    </>
                </Box>
            </Modal>

            <Modal
                open={paymentFailure}
                disableBackdropClick={false}
                onClose={handleClose}
                sx={{ border: 'none', zIndex: 1300 }}>
                <Box
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '50%',
                        height: 'auto',
                        outline: 'none',
                        background: '#ffffff',
                        p: 4,
                        borderRadius: '8px',
                        padding: '2%',
                        justifyContent: 'center', alignItems: 'center',
                        "@media only screen and (max-device-width: 480px)": {
                            width: '90%',
                        }
                    }}
                >
                    <Grid2 sx={{ display: "flex", justifyContent: "end" }}>
                        <IconButton onClick={() => setPaymentFailure(false)}>
                            <CloseIcon sx={{ color: "black" }} />
                        </IconButton>
                    </Grid2>
                    <Grid2 sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                        <img src={errorIcon} alt="errorIcon" width='70'></img>
                    </Grid2>
                    <Grid2 sx={{ width: '100%', display: 'flex', justifyContent: 'center', flexDirection: "column", gap: "10px", marginTop: "10px", padding: "0px 20px" }}>
                        <Typography className={styles.payment_succ} >Payment Failed</Typography>
                        {paymentErrorMessage && <Typography className={styles.payment_msg}>Message: {paymentErrorMessage}</Typography>}
                        {paymentOrderId && <Typography className={styles.payment_msg}>Order No: {paymentOrderId}</Typography>}
                    </Grid2>
                </Box>
            </Modal>
    </>
)
}